import { hbs } from 'ember-cli-htmlbars';
export default hbs("<option ...attributes>{{yield}}</option>")